
(function () {
  var SORT_CHEVRON_ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M7 10L12 15L17 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var FACET_REMOVE_ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
    '<circle cx="12" cy="12" r="10" fill="#fff"/>' +
    '<path d="M9.5 9.5L14.5 14.5M14.5 9.5L9.5 14.5" stroke="#95679a" stroke-width="1.5" stroke-linecap="round"/></svg>';

  function getFacetsContainer() {
    return document.querySelector("[data-fdr-active-facets]");
  }

  function getFacetsBlock() {
    return document.querySelector("[data-fdr-facets-block]");
  }

  function getFacetsDivider() {
    return document.querySelector("[data-fdr-meta-divider]");
  }

  function syncSidebarFacets() {
    var container = getFacetsContainer();
    var source = document.querySelector(".productList .active-facets");
    if (!container || !source) return;

    container.querySelectorAll(".FDR-sidebar-facet").forEach(function (chip) {
      chip.remove();
    });

    source.querySelectorAll(".actFilter").forEach(function (chip) {
      var label = chip.textContent.trim().toLowerCase();
      if (label.indexOf("clear all") !== -1) return;
      if (chip.classList.contains("btn-link")) return;

      var clone = chip.cloneNode(true);
      clone.classList.add("FDR-active-facet", "FDR-sidebar-facet");
      container.appendChild(clone);
    });

    refreshFacetsVisibility();
  }

  function observeActiveFacets() {
    var source = document.querySelector(".productList .active-facets");
    if (!source || source.dataset.fdrObserved === "true") return;
    source.dataset.fdrObserved = "true";
    source.classList.add("FDR-active-facets-source");

    if (typeof MutationObserver === "undefined") return;

    var observer = new MutationObserver(function () {
      syncSidebarFacets();
    });
    observer.observe(source, { childList: true, subtree: true, characterData: true });
  }

  function refreshFacetsVisibility() {
    var block = getFacetsBlock();
    var divider = getFacetsDivider();
    var container = getFacetsContainer();
    if (!block || !container) return;

    var hasFacets = container.querySelectorAll(".FDR-pill-facet, .FDR-sidebar-facet").length > 0;
    block.hidden = !hasFacets;
    if (divider) divider.hidden = !hasFacets;
  }

  function clearPillFilterState() {
    document.querySelectorAll(".collection-cp-pills__pill.is-active").forEach(function (pill) {
      pill.classList.remove("is-active");
      pill.setAttribute("aria-pressed", "false");
    });

    var container = getFacetsContainer();
    if (container) {
      container.querySelectorAll(".FDR-pill-facet").forEach(function (chip) {
        chip.remove();
      });
    }

    applyActivePillFilters();
    refreshFacetsVisibility();
  }

  function getActivePillFilters() {
    var pills = [];
    document.querySelectorAll(".collection-cp-pills__pill.is-active[data-collection-id]").forEach(function (pill) {
      pills.push({
        id: pill.getAttribute("data-collection-id"),
        handle: pill.getAttribute("data-collection-handle") || ""
      });
    });
    return pills;
  }

  function getActivePillCollectionIds() {
    return getActivePillFilters().map(function (pill) {
      return pill.id;
    });
  }

  function addPillFacetChip(pill) {
    var container = getFacetsContainer();
    if (!container || !pill) return;

    var collectionId = pill.getAttribute("data-collection-id");
    var chip = document.createElement("button");
    chip.type = "button";
    chip.className = "FDR-active-facet FDR-pill-facet";
    chip.setAttribute("data-collection-id", collectionId);
    chip.setAttribute("aria-label", "Remove " + pill.textContent.trim() + " filter");
    chip.innerHTML =
      '<span class="FDR-pill-facet__label">' +
      pill.textContent.trim() +
      '</span><span class="FDR-pill-facet__remove" aria-hidden="true">' +
      FACET_REMOVE_ICON +
      "</span>";
    chip.addEventListener("click", function () {
      removePillFilter(collectionId);
    });
    container.appendChild(chip);
  }

  function syncPillFacets() {
    var container = getFacetsContainer();
    if (!container) return;

    container.querySelectorAll(".FDR-pill-facet").forEach(function (chip) {
      chip.remove();
    });

    document.querySelectorAll(".collection-cp-pills__pill.is-active[data-collection-id]").forEach(addPillFacetChip);
    refreshFacetsVisibility();
  }

  function removePillFilter(collectionId) {
    var pill = document.querySelector('.collection-cp-pills__pill[data-collection-id="' + collectionId + '"]');
    if (pill) {
      pill.classList.remove("is-active");
      pill.setAttribute("aria-pressed", "false");
    }

    var container = getFacetsContainer();
    if (container) {
      container.querySelectorAll('.FDR-pill-facet[data-collection-id="' + collectionId + '"]').forEach(function (chip) {
        chip.remove();
      });
    }

    applyActivePillFilters();
    refreshFacetsVisibility();
  }

  function clearAllFilters() {
    clearPillFilterState();

    document.querySelectorAll(".FDR-active-facets-source .actFilter, .FDR-active-facets-source a.btn-link").forEach(function (link) {
      if (link.textContent.trim().toLowerCase().indexOf("clear all") !== -1) {
        link.click();
      }
    });

    var container = getFacetsContainer();
    if (container) {
      container.querySelectorAll(".FDR-sidebar-facet").forEach(function (chip) {
        chip.remove();
      });
    }

    refreshFacetsVisibility();
  }

  function setupMetaLeft(metaLeft, productCount, activeFacets) {
    if (!metaLeft) return;

    if (productCount) {
      var countBlock = document.createElement("div");
      countBlock.className = "FDR-filters-meta__count";

      var countClone = productCount.cloneNode(true);
      var countText = countClone.querySelector(".filters-toolbar__product-count");
      if (countText) {
        countText.innerHTML = countText.innerHTML
          .replace(/Showing:/gi, "<strong>Showing:</strong>")
          .replace(/(\d[\d,\s\-]*(?:of \d+)?\s*Results?)/i, '<span class="FDR-filters__count-value">$1</span>');
      }
      countBlock.appendChild(countClone);
      metaLeft.appendChild(countBlock);
    }

    var divider = document.createElement("div");
    divider.className = "FDR-filters-meta__divider";
    divider.setAttribute("data-fdr-meta-divider", "");
    divider.setAttribute("aria-hidden", "true");
    divider.hidden = true;
    metaLeft.appendChild(divider);

    var facetsBlock = document.createElement("div");
    facetsBlock.className = "FDR-filters-meta__facets";
    facetsBlock.setAttribute("data-fdr-facets-block", "");
    facetsBlock.hidden = true;

    var facetsLabel = document.createElement("span");
    facetsLabel.className = "FDR-filters__facets-label";
    facetsLabel.textContent = "Filters:";
    facetsBlock.appendChild(facetsLabel);

    var fdrActiveFacets = document.createElement("div");
    fdrActiveFacets.className = "FDR-active-facets";
    fdrActiveFacets.setAttribute("data-fdr-active-facets", "");
    facetsBlock.appendChild(fdrActiveFacets);

    var clearAll = document.createElement("button");
    clearAll.type = "button";
    clearAll.className = "FDR-clear-all";
    clearAll.textContent = "Clear All";
    clearAll.addEventListener("click", clearAllFilters);
    facetsBlock.appendChild(clearAll);

    metaLeft.appendChild(facetsBlock);

    if (activeFacets) {
      observeActiveFacets();
      syncSidebarFacets();
    } else {
      refreshFacetsVisibility();
    }
  }

  function applyDefaultSort() {
    return false;
  }

  function isMobileFiltersViewport() {
    return window.matchMedia("(max-width: 1024px)").matches;
  }

  function getFilterDrawerParts() {
    var root = document.getElementById("Collection") || document;
    var filterbar = root.querySelector(".reeawtretv.sidebar.filterbar.mbhide");
    var overlay = null;
    var sidebarTags = null;

    document.querySelectorAll(".bg-overlayds").forEach(function (el) {
      if (!overlay && el.parentNode === document.body) overlay = el;
    });
    document.querySelectorAll(".sidebar_tags.main-all-d-none").forEach(function (el) {
      if (!sidebarTags && el.parentNode === document.body) sidebarTags = el;
    });

    if (!overlay && filterbar) overlay = filterbar.querySelector(".bg-overlayds");
    if (!sidebarTags && filterbar) sidebarTags = filterbar.querySelector(".sidebar_tags.main-all-d-none");
    if (!overlay) overlay = root.querySelector(".bg-overlayds");
    if (!sidebarTags) sidebarTags = root.querySelector(".sidebar_tags.main-all-d-none");

    var drawerSidebar = sidebarTags && sidebarTags.querySelector(".all-filter-collection.sidebar");

    return {
      root: root,
      filterbar: filterbar,
      overlay: overlay,
      sidebarTags: sidebarTags,
      drawerSidebar: drawerSidebar
    };
  }

  function ensureMobileFilterPortal() {
    if (!isMobileFiltersViewport()) return;

    var parts = getFilterDrawerParts();
    if (!parts.filterbar) return;

    if (parts.overlay && parts.overlay.parentNode !== document.body) {
      document.body.appendChild(parts.overlay);
    }

    if (parts.sidebarTags && parts.sidebarTags.parentNode !== document.body) {
      parts.sidebarTags.classList.add("FDR-mobile-filter-drawer");
      document.body.appendChild(parts.sidebarTags);
    }
  }

  function hideFilterOverlay(overlay) {
    if (!overlay) return;

    overlay.setAttribute("hidden", "");
    overlay.setAttribute("aria-hidden", "true");
    overlay.style.removeProperty("display");
    overlay.style.removeProperty("opacity");
    overlay.style.removeProperty("visibility");
  }

  function showFilterOverlay(overlay) {
    if (!overlay) return;

    overlay.removeAttribute("hidden");
    overlay.setAttribute("aria-hidden", "false");
    overlay.style.removeProperty("display");
    overlay.style.removeProperty("opacity");
    overlay.style.removeProperty("visibility");
  }

  function resetFiltersDrawerState() {
    var parts = getFilterDrawerParts();

    if (parts.sidebarTags) parts.sidebarTags.classList.remove("active");
    if (parts.drawerSidebar) parts.drawerSidebar.classList.remove("active");
    if (parts.filterbar) parts.filterbar.classList.remove("active");

    document.querySelectorAll(".all-filter-collection").forEach(function (el) {
      el.classList.remove("active");
    });

    document.body.classList.remove("FDR-filters-open");
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";

    document.querySelectorAll(".bg-overlayds").forEach(hideFilterOverlay);

    if (window.jQuery) {
      window.jQuery("html, body").css("overflow", "");
      window.jQuery(".bg-overlayds").stop(true, true).hide();
    }
  }

  function openAllFilters() {
    if (isMobileFiltersViewport()) {
      ensureMobileFilterPortal();
    }

    var parts = getFilterDrawerParts();

    if (parts.sidebarTags) parts.sidebarTags.classList.add("active");
    if (parts.drawerSidebar) parts.drawerSidebar.classList.add("active");
    if (parts.filterbar) parts.filterbar.classList.add("active");

    showFilterOverlay(parts.overlay);
    document.body.classList.add("FDR-filters-open");
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";

    if (window.jQuery) {
      window.jQuery("html").css("overflow", "hidden");
    }
  }

  function closeAllFilters() {
    resetFiltersDrawerState();
  }

  function bindDrawerClose() {
    if (document.body.dataset.fdrDrawerCloseBound === "true") return;
    document.body.dataset.fdrDrawerCloseBound = "true";

    function handleDrawerCloseEvent(e) {
      if (!document.body.classList.contains("FDR-filters-open")) return;

      if (e.target.closest(".close-btn-allfilter, .closeFilter")) {
        e.preventDefault();
        closeAllFilters();
        return;
      }

      if (e.target.closest(".under-allfilter-collection")) return;

      if (e.target.closest(".bg-overlayds") || e.target.closest(".FDR-mobile-filter-drawer")) {
        e.preventDefault();
        closeAllFilters();
      }
    }

    document.addEventListener("click", handleDrawerCloseEvent);
    document.addEventListener("touchend", handleDrawerCloseEvent);
  }

  function updateTrackDragState(track) {
    if (!track) return;
    var scrollable = track.scrollWidth > track.clientWidth + 2;
    track.classList.toggle("is-scrollable", scrollable);
  }

  function initPillDragScroll(track) {
    if (!track || track.dataset.dragReady === "true") return;
    track.dataset.dragReady = "true";

    updateTrackDragState(track);
    window.addEventListener("resize", function () {
      updateTrackDragState(track);
    });

    var isDown = false;
    var moved = false;
    var startX = 0;
    var scrollLeft = 0;

    track.addEventListener("mousedown", function (e) {
      if (e.button !== 0 || !track.classList.contains("is-scrollable")) return;
      isDown = true;
      moved = false;
      startX = e.pageX;
      scrollLeft = track.scrollLeft;
      track.classList.add("is-dragging");
    });

    track.addEventListener("mouseleave", function () {
      isDown = false;
      track.classList.remove("is-dragging");
    });

    track.addEventListener("mouseup", function () {
      isDown = false;
      track.classList.remove("is-dragging");
    });

    track.addEventListener("mousemove", function (e) {
      if (!isDown) return;
      e.preventDefault();
      var walk = e.pageX - startX;
      if (Math.abs(walk) > 4) moved = true;
      track.scrollLeft = scrollLeft - walk;
    });

    track.addEventListener(
      "click",
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      },
      true
    );
  }

  function splitDataAttribute(value) {
    if (!value) return [];
    return value
      .split(",")
      .map(function (entry) {
        return entry.trim();
      })
      .filter(Boolean);
  }

  function productMatchesCollection(productEl, collectionId, collectionHandle) {
    var idList = splitDataAttribute(productEl.getAttribute("data-collection-ids"));
    if (collectionId && idList.indexOf(String(collectionId)) !== -1) return true;

    var handleList = splitDataAttribute(productEl.getAttribute("data-collection-handles"));
    if (collectionHandle && handleList.indexOf(String(collectionHandle)) !== -1) return true;

    return false;
  }

  function filterGridItems(activePills) {
    var items = document.querySelectorAll(".productList .grid-products .grid__item");
    var visibleCount = 0;

    items.forEach(function (item) {
      var productEl = item.querySelector(".grid-view-item");
      var show = !activePills.length;

      if (activePills.length) {
        if (!productEl) {
          show = false;
        } else {
          show = activePills.some(function (pill) {
            return productMatchesCollection(productEl, pill.id, pill.handle);
          });
        }
      }

      item.classList.toggle("FDR-pill-hidden", !show);
      item.setAttribute("aria-hidden", show ? "false" : "true");
      if (show) visibleCount += 1;
    });

    setPillFilterActiveState(activePills.length > 0);
    updatePillResultCount(activePills.length ? visibleCount : null);
    syncEmptyResultsState();
  }

  function updatePillResultCount(visibleCount) {
    var countValue = document.querySelector(".FDR-filters__count-value");
    if (!countValue) return;

    if (visibleCount === null) {
      var sourceCount = document.querySelector(".FDR-toolbar-source .filters-toolbar__product-count");
      if (sourceCount) {
        var match = sourceCount.textContent.match(/(\d[\d,\s\-]*(?:of \d+)?\s*Results?)/i);
        if (match) {
          countValue.textContent = match[1].trim();
          return;
        }
      }
      return;
    }

    countValue.textContent = visibleCount + " Result" + (visibleCount === 1 ? "" : "s");
  }

  function setPillFilterActiveState(active) {
    document.body.classList.toggle("FDR-pill-filter-active", active);

    if (window.jQuery) {
      window.jQuery(window).off("scroll.fdrPillFilter load.fdrPillFilter delayed-resize.fdrPillFilter");
      if (active) {
        window.jQuery(".infinitpagin a.infinite").hide();
      }
    }
  }

  var pillFilterLoadPending = false;
  var gridObserverPaused = false;
  var MAX_PILL_FILTER_LOAD_ATTEMPTS = 24;

  function getNextPageUrl() {
    var link = document.querySelector(".infinitpagin a.infinite, .infinitpagin a.loadMore");
    return link && link.href ? link.href : null;
  }

  function updatePaginationFromDoc(doc) {
    var newPagin = doc.querySelector(".infinitpagin");
    var paginEl = document.querySelector(".infinitpagin");
    if (newPagin && paginEl) {
      paginEl.innerHTML = newPagin.innerHTML;
      return;
    }
    var paginOuter = document.querySelector(".infinitpaginOuter");
    if (paginOuter) paginOuter.remove();
  }

  function fetchNextProductPageItems() {
    return new Promise(function (resolve) {
      var url = getNextPageUrl();
      if (!url) {
        resolve([]);
        return;
      }

      fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var newItems = doc.querySelectorAll(".productList .grid-products .grid__item");
          var nodes = [];

          newItems.forEach(function (item) {
            nodes.push(document.importNode(item, true));
          });

          updatePaginationFromDoc(doc);
          resolve(nodes);
        })
        .catch(function () {
          resolve([]);
        });
    });
  }

  function setPillFilterLoadingState(loading) {
    document.body.classList.toggle("FDR-pill-filter-loading", loading);

    if (window.jQuery) {
      if (loading) {
        window.jQuery("body").addClass("loading hideOverly");
      } else {
        window.jQuery("body").removeClass("loading hideOverly");
      }
    } else {
      document.body.classList.toggle("loading", loading);
    }
  }

  function appendProductPageItems(nodes) {
    var grid = document.querySelector(".productList .grid-products");
    if (!grid || !nodes.length) return;
    nodes.forEach(function (node) {
      grid.appendChild(node);
    });
  }

  function loadAllRemainingProductPages() {
    return new Promise(function (resolve) {
      var attempt = 0;
      var pendingNodes = [];

      function finish() {
        appendProductPageItems(pendingNodes);
        resolve();
      }

      function loadNext() {
        if (!getNextPageUrl() || attempt >= MAX_PILL_FILTER_LOAD_ATTEMPTS) {
          finish();
          return;
        }

        attempt += 1;
        fetchNextProductPageItems().then(function (nodes) {
          if (!nodes.length) {
            finish();
            return;
          }
          pendingNodes = pendingNodes.concat(nodes);
          loadNext();
        });
      }

      loadNext();
    });
  }

  function syncEmptyResultsState() {
    var emptyEl = document.querySelector("[data-fdr-no-results]");
    var grid = document.querySelector(".productList .grid-products");
    if (!emptyEl || !grid) return;

    var activePills = getActivePillFilters();
    var visibleItems = activePills.length
      ? grid.querySelectorAll(".grid__item:not(.FDR-pill-hidden)")
      : grid.querySelectorAll(".grid__item");
    var isEmpty = visibleItems.length === 0;

    emptyEl.hidden = !isEmpty;
    grid.hidden = isEmpty;
  }

  function syncToolbarResultCountFromSource() {
    var sourceCount = document.querySelector(".FDR-toolbar-source .filters-toolbar__product-count");
    var countValue = document.querySelector(".FDR-filters__count-value");
    if (!sourceCount || !countValue || getActivePillCollectionIds().length) return;

    var match = sourceCount.textContent.match(/(\d[\d,\s\-]*(?:of \d+)?\s*Results?)/i);
    if (match) countValue.textContent = match[1].trim();
  }

  function bindCollectionFilterAjax() {
    if (document.body.dataset.fdrAjaxBound === "true" || !window.jQuery) return;
    document.body.dataset.fdrAjaxBound = "true";

    window.jQuery(document).ajaxComplete(function (event, xhr, settings) {
      if (!document.body.classList.contains("template-collection")) return;
      if (!settings.url || settings.url.indexOf("/collections/") === -1) return;

      syncToolbarResultCountFromSource();

      if (getActivePillFilters().length) {
        filterGridItems(getActivePillFilters());
      } else {
        syncEmptyResultsState();
      }
    });
  }

  function applyActivePillFilters(skipLoadAll) {
    var activePills = getActivePillFilters();

    filterGridItems(activePills);

    if (!activePills.length) {
      setPillFilterLoadingState(false);
      return;
    }

    if (skipLoadAll || pillFilterLoadPending) return;

    if (!getNextPageUrl()) return;

    pillFilterLoadPending = true;
    gridObserverPaused = true;
    setPillFilterLoadingState(true);

    loadAllRemainingProductPages().then(function () {
      pillFilterLoadPending = false;
      gridObserverPaused = false;
      setPillFilterLoadingState(false);
      filterGridItems(getActivePillFilters());
    });
  }

  function observeProductGrid() {
    var grid = document.querySelector(".grid-products");
    if (!grid || grid.dataset.fdrGridObserved === "true") return;
    grid.dataset.fdrGridObserved = "true";

    if (typeof MutationObserver === "undefined") return;

    var observer = new MutationObserver(function () {
      if (gridObserverPaused || pillFilterLoadPending) return;
      if (getActivePillFilters().length) {
        filterGridItems(getActivePillFilters());
      }
    });
    observer.observe(grid, { childList: true });
  }

  function initPillFilter(nav) {
    var track = nav.querySelector("[data-pill-track]");
    var pills = nav.querySelectorAll(".collection-cp-pills__pill[data-collection-id]");
    if (!pills.length) return;

    initPillDragScroll(track);

    pills.forEach(function (pill) {
      pill.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        var isActive = pill.classList.contains("is-active");

        if (isActive) {
          pill.classList.remove("is-active");
          pill.setAttribute("aria-pressed", "false");
        } else {
          pill.classList.add("is-active");
          pill.setAttribute("aria-pressed", "true");
        }

        if (pillFilterLoadPending) {
          filterGridItems(getActivePillFilters());
          syncPillFacets();
          return;
        }

        applyActivePillFilters();
        syncPillFacets();
      });
    });
  }

  function removeLegacyMetacolSlider() {
    if (!document.body.classList.contains("template-collection")) return;
    document.querySelectorAll(".metacol-slider").forEach(function (slider) {
      slider.remove();
    });
  }

  function initCollectionPills() {
    document.querySelectorAll('.collection-cp-pills[data-filter-in-page="true"]').forEach(initPillFilter);
    document.querySelectorAll("[data-pill-track]").forEach(function (track) {
      if (!track.closest('[data-filter-in-page="true"]')) {
        initPillDragScroll(track);
      }
      updateTrackDragState(track);
    });

    window.setTimeout(function () {
      document.querySelectorAll("[data-pill-track]").forEach(updateTrackDragState);
    }, 150);
  }

  function initFilterRedesign() {
    var productList = document.querySelector(".productList");
    var toolbar = productList && productList.querySelector("[data-fdr-toolbar]");
    if (!productList || !toolbar || toolbar.dataset.fdrReady === "true") return;

    var sourceToolbar = productList.querySelector(".filters-toolbar.flex");
    var sortBy = sourceToolbar && sourceToolbar.querySelector(".filters-toolbar__item.text-right");
    var productCount = sourceToolbar && sourceToolbar.querySelector(".filters-toolbar__item.flbarCount");
    var activeFacets = productList.querySelector(".active-facets");

    var metaLeft = toolbar.querySelector("[data-fdr-meta-left]");
    var metaRight = toolbar.querySelector("[data-fdr-meta-right]");
    var fdrSortWrap = metaRight && metaRight.querySelector(".FDR-filters__sort-wrap");
    var showAllFilters = metaRight && metaRight.querySelector(".FDR-show-all-filters");

    setupMetaLeft(metaLeft, productCount, activeFacets);

    if (sourceToolbar) {
      sourceToolbar.classList.add("FDR-toolbar-source");
    }

    if (sortBy && fdrSortWrap) {
      var sortClone = sortBy.cloneNode(true);
      sortClone.classList.add("FDR-sort-control");
      if (sortClone.querySelector("select")) {
        var chevron = document.createElement("span");
        chevron.className = "FDR-sort-chevron";
        chevron.innerHTML = SORT_CHEVRON_ICON;
        sortClone.appendChild(chevron);
      }
      fdrSortWrap.appendChild(sortClone);
    }

    toolbar.dataset.fdrReady = "true";

    initCollectionPills();
    observeProductGrid();
    removeLegacyMetacolSlider();
    bindDrawerClose();
    bindCollectionFilterAjax();
    syncEmptyResultsState();

    var showAllFiltersBtn = toolbar.querySelector(".FDR-show-all-filters");
    if (showAllFiltersBtn && showAllFiltersBtn.dataset.fdrClickBound !== "true") {
      showAllFiltersBtn.dataset.fdrClickBound = "true";
      showAllFiltersBtn.addEventListener("click", function (e) {
        e.preventDefault();
        openAllFilters();
      });
    }
  }

  function scheduleInit(attempt) {
    if (applyDefaultSort()) return;

    ensureMobileFilterPortal();
    resetFiltersDrawerState();
    removeLegacyMetacolSlider();

    if (document.querySelector("[data-fdr-toolbar][data-fdr-ready='true']")) return;
    if (!document.querySelector(".productList")) return;

    var sidebarPending =
      document.querySelector('[data-section-type="collection-template"]') &&
      !document.querySelector(".main-all.all-filter-collection.sidebar") &&
      (attempt || 0) < 20;

    if (sidebarPending) {
      window.setTimeout(function () {
        scheduleInit((attempt || 0) + 1);
      }, 50);
      return;
    }

    initFilterRedesign();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      scheduleInit(0);
    });
  } else {
    scheduleInit(0);
  }
})();
